import { httpClient } from '@/services/http/httpClient'

export type AIUsageData = {
  model: string
  inputUsage: number
  outputUsage: number
  priceInput: number
  priceOutput: number
  costInput: number
  costOutput: number
  totalCost: number
}

export type GetAIUsageResponse = {
  tennantId: string
  usage: AIUsageData[]
}

export type GetAIUsageParams = {
  tennantId: string
  startDate?: string
  endDate?: string
}

export async function getAIUsage({
  tennantId,
  startDate,
  endDate,
}: GetAIUsageParams): Promise<GetAIUsageResponse> {
  const { data } = await httpClient.get(`/tennants/${tennantId}/ai-usage`, {
    params: {
      startDate,
      endDate,
    },
  })

  return data
}
